// Service Worker Registration pour Éphéméride Duala PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  // Vérifier si les Service Workers sont supportés
  if (!('serviceWorker' in navigator)) {
    console.log('[SW Registration] Service Workers non supportés dans ce navigateur');
    return;
  }

  // Attendre que la page soit chargée
  window.addEventListener('load', () => {
    // Construire l'URL du service worker
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      // En développement local
      console.log('[SW Registration] Mode localhost détecté');
      checkValidServiceWorker(swUrl, config);
      
      navigator.serviceWorker.ready.then(() => {
        console.log('[SW Registration] Application prête avec Service Worker en localhost');
      });
    } else {
      // En production
      console.log('[SW Registration] Mode production détecté');
      registerValidSW(swUrl, config);
    }
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl, {
      scope: '/'
    })
    .then((registration) => {
      console.log('[SW Registration] Service Worker enregistré avec succès. Scope:', registration.scope);

      // Écouter les mises à jour
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          console.log('[SW Registration] État du Service Worker:', installingWorker.state);

          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Nouvelle version disponible
              console.log('[SW Registration] Nouveau contenu disponible; actualisation recommandée.');
              
              // Callback onUpdate
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }

              // Proposer à l'utilisateur de recharger (optionnel)
              // Commenté en production pour éviter d'interrompre l'expérience utilisateur
              /*
              if (window.confirm('Une nouvelle version de l\'application est disponible. Recharger maintenant ?')) {
                installingWorker.postMessage({ type: 'SKIP_WAITING' });
                window.location.reload();
              }
              */
            } else {
              // Première installation
              console.log('[SW Registration] Contenu mis en cache pour utilisation hors-ligne.');
              
              // Callback onSuccess
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };

      // Vérifier les mises à jour périodiquement (toutes les 6 heures)
      setInterval(() => {
        console.log('[SW Registration] Vérification des mises à jour...');
        registration.update();
      }, 6 * 60 * 60 * 1000);
    })
    .catch((error) => {
      console.error('[SW Registration] Erreur lors de l\'enregistrement du Service Worker:', error);
      
      // Afficher un message d'erreur plus détaillé selon le type d'erreur
      if (error.name === 'SecurityError') {
        console.error('[SW Registration] Erreur de sécurité - L\'application doit être servie en HTTPS (sauf localhost)');
      } else if (error.message && error.message.includes('Script evaluation failed')) {
        console.error('[SW Registration] Échec de l\'évaluation du script Service Worker');
        console.error('[SW Registration] Vérifiez que le fichier service-worker.js est accessible à:', swUrl);
      } else if (error.message && error.message.includes('unsupported MIME type')) {
        console.error('[SW Registration] Type MIME incorrect pour le Service Worker');
        console.error('[SW Registration] Le fichier doit être servi avec Content-Type: application/javascript ou text/javascript');
      } else {
        console.error('[SW Registration] Erreur inconnue:', error.message);
      }
      
      // Ne pas bloquer l'application en cas d'erreur du Service Worker
      console.log('[SW Registration] L\'application continuera de fonctionner sans mode hors-ligne');
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Vérifier si le service worker existe
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' }
  })
    .then((response) => {
      // S'assurer que le service worker existe et qu'on a bien du JavaScript
      const contentType = response.headers.get('content-type');
      
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // Service worker non trouvé - désenregistrer et recharger
        console.log('[SW Registration] Service Worker non trouvé ou type MIME incorrect. Nettoyage...');
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            console.log('[SW Registration] Service Worker désenregistré, rechargement de la page');
            window.location.reload();
          });
        });
      } else {
        // Service worker trouvé - procéder à l'enregistrement
        console.log('[SW Registration] Service Worker trouvé, enregistrement...');
        registerValidSW(swUrl, config);
      }
    })
    .catch((error) => {
      console.log('[SW Registration] Pas de connexion internet ou erreur réseau:', error.message);
      console.log('[SW Registration] L\'application peut fonctionner en mode hors-ligne si déjà mise en cache');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        console.log('[SW Registration] Désenregistrement du Service Worker');
        return registration.unregister();
      })
      .then(() => {
        console.log('[SW Registration] Service Worker désenregistré avec succès');
      })
      .catch((error) => {
        console.error('[SW Registration] Erreur lors du désenregistrement:', error.message);
      });
  }
}

// Fonction utilitaire pour vérifier si le SW est enregistré
export function isRegistered() {
  return navigator.serviceWorker && navigator.serviceWorker.controller !== null;
}

// Fonction pour forcer la mise à jour
export function forceUpdate() {
  if ('serviceWorker' in navigator) {
    console.log('[SW Registration] Forçage de la mise à jour du Service Worker');
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.update();
      });
    });
  }
}

// Fonction pour obtenir l'état du Service Worker
export function getStatus() {
  if (!('serviceWorker' in navigator)) {
    return { supported: false, registered: false };
  }
  
  return {
    supported: true,
    registered: isRegistered(),
    controller: navigator.serviceWorker.controller ? true : false
  };
}
